import { observable } from "mobx";
import { Type } from "class-transformer";
import BankExportDownloadResponse from "./bankExportDownloadResponse";
import TransferType from "./transferType";
import type { IBankExportDetail } from "./bankExport";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InternalTransferExportDetailResponse implements IBankExportDetail {
  id!: string;

  @observable
  name!: string;

  @observable
  transferType!: TransferType;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  createdBy!: string;

  @observable
  paymentsIncludedCount!: number;

  @observable
  @Type(() => BankExportDownloadResponse)
  downloads!: BankExportDownloadResponse[];
}
